module.exports = __webpack_public_path__ + "static/media/contact.1ee1e3bb.png";